import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=e610bc82&"
import script from "./MoreInfo.vue?vue&type=script&lang=js&"
export * from "./MoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports